import { isEdu } from 'owa-session-store';
import isEduFromBpos from 'owa-bpos-utils/lib/isEdu';
import type { MailboxInfo } from 'owa-client-types';
import { isAccountFeatureEnabled } from 'owa-feature-flags';

/**
 * Returns true if the mailbox is corresponds to an EDU user. Takes experimental flags into account.
 * @param mailboxInfo
 */
export function isEduConsolidated(mailboxInfo: MailboxInfo): boolean {
    return isAccountFeatureEnabled('cal-collab-useEduCheckFromBpos', mailboxInfo)
        ? isEduFromBpos(mailboxInfo)
        : isEdu(mailboxInfo);
}
